<template>
  <div>
    <b-overlay :show="
                                                          !userStore.isShipsLoaded ||
                                                          !deviceStore.isAgreementLoaded ||
                                                          momentaryStore.isBusy1 ||
                                                          (momentaryStore.isBusy) ||
                                                          $store.state.routes.progress.isCalculating ||
                                                          is_catalog_preparing ||
                                                          is_items_by_route_preparing
                                                        " bg-color="white" class="mt-1" :opacity="getOverlayOpacity">
      <template #overlay>
        <div v-if="is_catalog_preparing" class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p>{{ $t('route.loadingCatalog') }}</p>
        </div>
      </template>
  
      <b-container fluid>
        <b-row class="mt-2">
          <b-col order="4" order-lg="1" :lg="getTabSize()">
            <b-tabs card v-model="tabIndexProvider" small class="compact-tabs">
              <b-tab title="Primar">
                <b-tabs v-model="tabIndexService" small class="compact-tabs">
                  <b-tab title="S-63">
                    <div class="mb-3">
                      <b-button size="sm" variant="primary" @click="downloadFolioPDF">
                        <i class="fas fa-download mr-2" />
                        Download PDF
                      </b-button>
                    </div>
                    <folio-table ref="folio-tab" @call-parent-method="aaaa" />
                  </b-tab>
                  <b-tab title="S-102">
                    <NoService />
                  </b-tab>
                  <b-tab title="Navarea">
                    <NoService />
                  </b-tab>
                </b-tabs>
              </b-tab>
            </b-tabs>
          </b-col>
  
          <b-col order="2" order-lg="2" :lg="getMapSize()">
            <b-row>
              <b-col class="text-left">
                <div class="d-flex align-items-center">
                  <div class="ship-badge" :class="{ 'ship-badge--clickable': hasOwnShipPosition }" @click="centerMapOnShip">
                    <!-- <i class="fas fa-ship mr-2" /> -->
                    <span>{{ getShipName }}</span>
                  </div>
                </div>
              </b-col>
              <b-col>
                <!-- <Breadcrumbs :items="breadcrumbItems" /> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <folio-map ref="folio-map" :height="map_size" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { eventBus } from '@/main'
import { routes_map } from '@/main'
import router from '@/router'
import { useMomentaryStore } from '@/stores/momentary'
import FolioMap from '@/views/ship-folio/FolioMap.vue'
import { useRoutesStore } from '@/stores/routes'
import { mapStores } from 'pinia'
import FolioTable from '@/views/ship-folio/FolioTable.vue'
import { myAxios, myAxiosRetry } from '@/services/myAxios'
import { getMwendBaseUrl } from '@/utils/api-config';
import dayjs from 'dayjs'
import { useUserStore } from '@/stores/user'
import { useDeviceStore } from '@/stores/device'
import { useFleetStore } from '@/stores/fleet'
import { loadAgreements, loadShips, prepareCatalog } from '@/helpers/api'
import * as utils from '@/utils/utils'
import NoService from "@/views/ship-folio/NoService.vue";
import { setTimeout } from 'core-js'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

pdfMake.vfs = pdfFonts.pdfMake.vfs;


export default {
  components: {
    FolioMap: FolioMap,
    FolioTable: FolioTable,
    NoService: NoService
  },
  data() {
    return {
      show2D: false,
      isNeedCheckSafety: false,
      isNeedCheckSafetyWarning: false,

      showRouteNameModal: false,
      routeNameInput: '',

      pathFile: null,
      routeFile: null,
      zonesFile: null,

      selected_ship: '',
      select_ship_disabled: false,
      ships: [],

      needToRestoreSearch: false,
      preparingPassagePlan: true,

      displayContent: 'showRoute',
      map_info_text: '',
      map_info_object: '',

      windowWidth: window.innerWidth,
      mapHeight: window.innerHeight / 1.2,
      mapHeightMobile: window.innerHeight / 1.8,

      map: routes_map,

      is_catalog_preparing: false,
      is_items_by_route_preparing: false,

      fields: [
        { key: 'name', label: 'name', type: 'string', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'lat', label: 'Lat', type: 'number', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'lon', label: 'Lon', type: 'number', tdClass: 'small-black', thClass: 'small-gray' },
      ],

      show_spinner: false,
      // priceCalculating: false,
      openCellsList: false,
      selectedPeriod: { period_code: '4', period: '3' },

      cellList: '',

      agreement: null,

      selected_ecdis: null,
      checkOrder: false,
      aioLayer: null,
      activeAIOItem: null,
      isDataLoading: false, // Флаг загрузки данных AIO, Navarea
      
      tabIndexProvider: 0, // Индекс выбранной вкладки провайдера (Primar/UKHO)
      tabIndexService: 0, // Индекс выбранной вкладки сервиса (S-63/S-102/Navarea)
    }
  },
  mounted() {
    myAxios.get('/api/v1/manage/test')

    window.addEventListener("resize", this.handleResize);

    eventBus.$off('switch-wp-tab')
    eventBus.$off('search-on-map')
    eventBus.$off('send-order-route')
    eventBus.$off('show-map-info')
    eventBus.$off('show-waypoints')
    eventBus.$off('save-nogo-zones')
    eventBus.$off('route-cleared')
    eventBus.$off('calculate-ukc')
    eventBus.$off('is-need-check-safety')
    eventBus.$off('show-calculate-time')
    eventBus.$off('switch-to-general-route')
    eventBus.$off('switch-to-wp')
    eventBus.$off('graph-diag-changed')
    eventBus.$off('clear-general-route-layers')
    eventBus.$off('draw-map-layers')
    eventBus.$off('map-drag-offset')

    loadShips().then(() => {
      loadAgreements().then(async () => {
        console.log('[Folio] mounted: loadShips/loadAgreements завершены');
        if (this.deviceStore.isDeviceIDExist) this.selected_ship = this.deviceStore.getDeviceID
        else this.selected_ship = this.userStore.getECDISShips[0]?.value ?? ''
        this.ships = this.userStore.getECDISShips

        this.select_ship_disabled = true
        this.is_catalog_preparing = true

        // loadUKHO_Publications().then(resp => {})

        // Загружаем фолио данные для выбранного корабля и ждем завершения
        console.log('[Folio] mounted: вызываем loadFolioData');
        await this.loadFolioData();

        // После загрузки данных готовим каталог и инициализируем карту
        prepareCatalog().then(resp => {
          this.is_catalog_preparing = false
          this.is_items_by_route_preparing = false

          let mapType = 'folio-map'
          if (this.$refs[mapType]) {
            this.$refs[mapType].init_map().then(() => {
              this.is_items_by_route_preparing = false
            })
          }
        })
      })
    })
  },
  watch: {
    selected_ship(newVal, oldVal) {
      // routes_map.clearRoute(true, true, false)
      this.deviceStore.selectDevice(newVal)
      // routes_map.redrawRoute()
      // routes_map.boundRoute()
      // routes_map.drawLogbookState()

      this.loadFolioData()
    },
  },
  computed: {
    dayjs() {
      return dayjs
    },
    getShipName() {
      if (this.selected_ship === "") return "";
      const ship = this.ships.find((e) => e.value === this.selected_ship);
      return ship ? ship.text : "";
    },

    getOverlayOpacity() {
      return this.$store.state.routes.progress.isCalculating ? 0.3 : 0.9
    },

    ...mapStores(useMomentaryStore, useRoutesStore, useUserStore, useDeviceStore, useFleetStore),

    is_mobile() {
      return this.windowWidth <= 760
    },
    map_size() {
      if (this.is_mobile) return window.innerHeight / 1.8
      else return window.innerHeight / 1.2
    },
    hasOwnShipPosition() {
      const pos = this.fleetStore?.selectedShipPosition;
      return Boolean(pos && Number.isFinite(Number(pos.lat)) && Number.isFinite(Number(pos.lon)));
    }
  },
  created() {
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    loadFolioData() {
      console.log('[Folio] loadFolioData: начало загрузки');
      
      // Очищаем существующие данные в сторе перед новой загрузкой, чтобы избежать отображения данных от предыдущего корабля
      this.deviceStore.resetOrderedData();
      
      return this.getHistory().then(resp => {
        console.log('[Folio] loadFolioData: getHistory вернул:', resp);
        
        if (!resp) {
          console.warn('[Folio] loadFolioData: resp is undefined!');
          resp = { orders: [] };
        }
        
        console.log('[Folio] loadFolioData: agreementProvider:', this.deviceStore.getAgreementProvider);
        console.log('[Folio] loadFolioData: agreementID:', this.deviceStore.getAgreementID);
        
        // Загружаем данные если у нас есть валидный ответ от getHistory (даже если agreementProvider пустой)
        // Это нужно для fallback данных которые приходят из primar-charts API
        if (resp.orders && resp.orders.length > 0) {
          const historyMap = new Map()
          const folioTableData = [] // Данные для таблицы

          console.log('[Folio] loadFolioData: getHistory результат:', resp.orders)

          if (!resp || !resp.orders) {
            console.warn('[Folio] loadFolioData: resp или resp.orders не определены!');
            return;
          }

          resp.orders.forEach(order => {
            const date = order.createdUtc
            const status = order.status
            
            // Проверяем, являются ли это fallback данные
            const isFallback = order.id && order.id.startsWith('primar-charts-')

            if (status === 'complete') {
              order.items.forEach(item => {
                const name = item.id

                let period = null
                
                // Преобразуем дату в формат YYYY-MM-DD
                if (date) {
                  try {
                    if (isFallback) {
                      // Для fallback данных createdUtc уже содержит дату окончания
                      // Просто форматируем её без прибавления месяцев
                      period = dayjs(date).format('YYYY-MM-DD')
                    } else {
                      // Для обычных данных прибавляем месяцы к дате начала
                      const monthsToAdd = Number(item.monthCount || 0)
                      period = dayjs(date).add(monthsToAdd, 'month').format('YYYY-MM-DD')
                    }
                  } catch (e) {
                    console.warn('[Folio] loadFolioData: ошибка при обработке даты:', date, e);
                  }
                }

                const existing = historyMap.get(name)
                // Обновляем если нет существующего или если новый период более свежий
                if (!existing || (period && dayjs(period).isAfter(dayjs(existing.expiryDate)))) {
                  historyMap.set(name, { name, expiryDate: period || 'Unknown' })
                }
                
                // Добавляем в данные для таблицы (из fallback или обычных заказов)
                if (order.id && order.id.startsWith('primar-charts-')) {
                  // Это fallback данные - добавляем в таблицу
                  console.log('[Folio] loadFolioData: добавляем fallback ячейку:', name);
                  const bandCode = name && name.length >= 3 ? Number(name[2]) : -1
                  const bandName = utils.getBandName(bandCode)
                  folioTableData.push({
                    name: name, // ID ячейки
                    band: bandName, // преобразованное имя band
                    expiryDate: period || 'Unknown'
                  })
                }
              })
            }
          })

          console.log('[Folio] loadFolioData: historyMap:', historyMap)
          console.log('[Folio] loadFolioData: folioTableData для таблицы:', folioTableData)
          
          this.deviceStore.addOrdersHistoryPrimar(Array.from(historyMap.values()))
          
          // Если есть данные fallback, добавляем их в orderedData для таблицы
          if (folioTableData.length > 0) {
            this.deviceStore.orderedData.primar.enc = folioTableData
            console.log('[Folio] loadFolioData: добавили данные в orderedData.primar.enc:', folioTableData)
          } else {
            console.warn('[Folio] loadFolioData: folioTableData пуста!');
          }
        } else {
          console.log('[Folio] loadFolioData: нет данных в resp.orders, пропускаем загрузку');
        }
      }).catch(err => {
        console.error('[Folio] loadFolioData: ошибка в getHistory:', err);
      })
    },

    centerMapOnShip() {
      if (!this.hasOwnShipPosition) {
        return;
      }
      const pos = this.fleetStore.selectedShipPosition;
      const lat = Number(pos.lat);
      const lon = Number(pos.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        return;
      }
      try {
        const folioMapComponent = this.$refs['folio-map'];
        const leafletMap = folioMapComponent?.foliomap?.map;
        
        if (leafletMap && typeof leafletMap.flyTo === 'function') {
          const currentZoom = leafletMap.getZoom ? leafletMap.getZoom() : 10;
          leafletMap.flyTo([lat, lon], Math.max(currentZoom, 10), { duration: 0.6 });
        }
      } catch (e) {
        console.error('centerMapOnShip error:', e);
      }
    },
    getHistory() {
      return new Promise(resolve => {
        if (!this.deviceStore.getDeviceID) {
          console.log('[Folio] getHistory: нет deviceID, возвращаем пусто');
          resolve({ orders: [] })
          return
        }

        // Используем только fallback прямо на primar-charts API
        console.log('[Folio] getHistory: запрашиваем прямо primar-charts');
        this.getPrimarCharts().then(chartsData => {
          console.log('[Folio] getHistory: успешно получены данные');
          resolve(chartsData);
        }).catch(error => {
          console.error('[Folio] getHistory: ошибка при получении primar-charts:', error);
          resolve({ orders: [] });
        })
      }
      )
    },
    /**
     * Получить данные о картах из прямого API прямара
     * Это используется как fallback когда первый запрос к orders/deviceid вернул пустой результат
     * @returns {Promise<Object>} - объект с структурой { orders: [...] } совместимой с getHistory
     */
    getPrimarCharts() {
      const deviceId = this.deviceStore.getDeviceID;
      const URL = `${getMwendBaseUrl()}/api/v1/primar-charts/${deviceId}`;
      
      console.log('[Folio] getPrimarCharts: запрашиваем fallback ручку:', URL);
      
      return new Promise((resolve, reject) => {
        myAxios.get(URL).then(resp => {
          console.log('[Folio] getPrimarCharts: ответ от fallback ручки:', resp.data);
          
          // Преобразуем результаты из primar-charts в формат orders
          // Каждая карта становится отдельным "заказом"
          const orders = [];
          
          if (resp.data.cells && Array.isArray(resp.data.cells)) {
            console.log('[Folio] getPrimarCharts: найдено карт:', resp.data.cells.length);
            
            const now = new Date();
            resp.data.cells.forEach(cell => {
              // Вычисляем monthCount на основе exp даты
              let monthCount = 0;
              if (cell.exp) {
                try {
                  const expDate = new Date(cell.exp);
                  if (!isNaN(expDate.getTime())) {
                    monthCount = (expDate.getFullYear() - now.getFullYear()) * 12 + 
                                 (expDate.getMonth() - now.getMonth());
                    // Убедимся, что monthCount неотрицательный
                    monthCount = Math.max(0, monthCount);
                  }
                } catch (e) {
                  console.warn('[Folio] getPrimarCharts: ошибка при парсинге exp даты:', cell.exp);
                }
              }
              
              // Создаем фиктивный "заказ" для каждой карты из primar-charts
              // Используем реальную дату из поля exp
              orders.push({
                id: `primar-charts-${cell.id}`, // уникальный ID
                createdUtc: cell.exp || null, // реальная дата окончания от API
                status: 'complete', // помечаем как завершенный
                items: [
                  {
                    id: cell.id, // ID карты
                    monthCount: monthCount, // вычисленное количество месяцев
                    price: 0, // нет данных о цене
                  }
                ],
                // Дополнительные поля для совместимости
                paymentMethod: '', // нет данных
                expiryDays: null, // нет данных о дням до истечения
              });
            });
          } else {
            console.log('[Folio] getPrimarCharts: нет поля cells или это не массив');
          }
          
          console.log('[Folio] getPrimarCharts: преобразовано в', orders.length, 'заказов');
          resolve({ orders });
        }).catch(error => {
          console.error(`[Folio] getPrimarCharts: ошибка при запросе к fallback ручке для ${deviceId}:`, error);
          reject(error);
        });
      });
    },
    showFolioCell(cellName) {
      this.$refs['folio-map'].showFolioCell(cellName)
    },
    getMapSize() {
      return 8
    },
    getTabSize() {
      return 4
    },
    aaaa() {
      // Пустой метод для обработки событий из FolioTable
    },

    downloadFolioPDF() {
      const folioTable = this.$refs['folio-tab'];
      if (!folioTable) {
        this.$bvToast.toast('Folio table not found', { title: 'Error', variant: 'danger' });
        return;
      }

      const cells = folioTable.getSortedCellsForPDF();
      if (!cells || cells.length === 0) {
        this.$bvToast.toast('No data to download', { title: 'Error', variant: 'warning' });
        return;
      }

      // Подготавливаем данные для PDF
      const shipName = this.getShipName || 'Unknown Ship';
      const currentDate = dayjs().format('DD/MM/YYYY HH:mm');
      
      // Построение таблицы
      const tableBody = [];
      
      // Заголовок таблицы
      tableBody.push([
        { text: 'Cell Name', style: 'tableHeader', alignment: 'center' },
        { text: 'Band', style: 'tableHeader', alignment: 'center' },
        { text: 'Valid Till', style: 'tableHeader', alignment: 'center' }
      ]);

      // Строки данных
      cells.forEach(cell => {
        tableBody.push([
          { text: cell.name || '—', style: 'tableText', alignment: 'left' },
          { text: cell.band || '—', style: 'tableText', alignment: 'left' },
          { text: cell.expiryDate || '—', style: 'tableText', alignment: 'center' }
        ]);
      });

      const docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        content: [
          {
            table: {
              widths: ['*', '*', '*'],
              headerRows: 1,
              body: [
                [
                  { text: 'FOLIO LIST', style: 'documentTitle', colSpan: 3, alignment: 'center' },
                  {},
                  {}
                ],
                [
                  { text: `Ship: ${shipName}`, style: 'documentInfo' },
                  { text: `Date: ${currentDate}`, style: 'documentInfo', colSpan: 2 },
                  {}
                ]
              ]
            }
          },
          { text: '\n' },
          {
            table: {
              widths: ['40%', '30%', '30%'],
              headerRows: 1,
              body: tableBody
            },
            layout: 'lightHorizontalLines'
          }
        ],
        styles: {
          documentTitle: {
            fontSize: 16,
            bold: true,
            color: '#1f2937'
          },
          documentInfo: {
            fontSize: 11,
            color: '#4b5563'
          },
          tableHeader: {
            bold: true,
            fontSize: 11,
            color: '#ffffff',
            fillColor: '#1f2937',
            alignment: 'center'
          },
          tableText: {
            fontSize: 10,
            color: '#1f2937'
          }
        },
        defaultStyle: {
          font: 'Roboto'
        }
      };

      // Генерируем PDF
      const filename = `Folio_${shipName}_${dayjs().format('YYYY-MM-DD_HH-mm')}.pdf`;
      pdfMake.createPdf(docDefinition).download(filename);
      
      this.$bvToast.toast(`Folio PDF downloaded: ${filename}`, {
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 2000
      });
    },
  },
}
</script>

<style scoped>
@import '@/assets/styles/components/buttons.css';

:deep(.compact-tabs .nav-tabs) {
  border-bottom: 1px solid #d1d9e6;
  display: flex;
  flex-wrap: wrap;
  /* Changed from nowrap to wrap */
  overflow-x: visible;
  /* Changed from auto to visible */
  overflow-y: visible;
  /* Changed from hidden to visible */
  scrollbar-width: thin;
  padding: 0.15rem 0.15rem 0;
}

:deep(.compact-tabs .nav-tabs .nav-item) {
  margin-bottom: 3px;
  /* Add some bottom margin for wrapped items */
  white-space: nowrap;
  flex: 0 0 auto;
  margin-right: 1px;
}

:deep(.compact-tabs .nav-link) {
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 0.4rem 0.4rem 0 0;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
  border-bottom: none;
  color: #5a6a85;
}

:deep(.compact-tabs .nav-link:hover:not(.active)) {
  background-color: rgba(108, 117, 125, 0.08);
  border-color: #e2e8f0;
  color: #495057;
}

:deep(.compact-tabs .nav-link.active) {
  background-color: #f8f9fa;
  background-image: linear-gradient(to bottom, #ffffff, #f8f9fa);
  border-color: #d1d9e6;
  color: #3a3f51;
  font-weight: 500;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.03);
}

:deep(.compact-tabs .tab-content) {
  border: 1px solid #d1d9e6;
  border-top: none;
  padding: 0.75rem 0.2rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #ffffff;
}

/* Hide scrollbar for Chrome/Safari */
:deep(.compact-tabs .nav-tabs::-webkit-scrollbar) {
  height: 3px;
  width: 0;
}

:deep(.compact-tabs .nav-tabs::-webkit-scrollbar-thumb) {
  background: rgba(108, 117, 125, 0.2);
  border-radius: 3px;
}

:deep(.tab-content)>.tab-pane {
  padding: 0;
}

:deep(.compact-tabs .tab-pane) {
  padding-top: 0.5rem;
}

</style>
